/* eslint-disable */
module.exports = function (config) {
    ;
    (function (para) {
        var p = para.sdk_url, n = para.name, w = window, d = document, s = 'script', x = null, y = null;
        if (typeof w['sensorsDataAnalytic201505'] !== 'undefined') {
            return false;
        }
        w['sensorsDataAnalytic201505'] = n;
        w[n] =
            w[n] ||
                function (a) {
                    return function () {
                        ;
                        (w[n]._q = w[n]._q || []).push([a, arguments]);
                    };
                };
        var ifs = [
            'track',
            'quick',
            'register',
            'registerPage',
            'registerOnce',
            'trackSignup',
            'trackAbtest',
            'setProfile',
            'setOnceProfile',
            'appendProfile',
            'incrementProfile',
            'deleteProfile',
            'unsetProfile',
            'identify',
            'login',
            'logout',
            'trackLink',
            'clearAllRegister',
            'getAppStatus'
        ];
        for (var i = 0; i < ifs.length; i++) {
            w[n][ifs[i]] = w[n].call(null, ifs[i]);
        }
        if (!w[n]._t) {
            ;
            (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0]);
            x.async = 1;
            x.src = p;
            x.setAttribute('charset', 'UTF-8');
            w[n].para = para;
            y.parentNode.insertBefore(x, y);
        }
    })({
        sdk_url: 'https://ucmp-static.sf-express.com/assets/sdks/sensorsdata-1.16.6.min.js',
        heatmap_url: 'https://ucmp-static.sf-express.com/assets/sdks/heatmap-1.16.6.min.js',
        name: 'sensors',
        server_url: config.env === 'production' ? 'https://ubs.sf-express.com/sa?project=useradd' : 'https://ubs.sf-express.com/sa?project=default',
        heatmap: {
            clickmap: 'default',
            collect_tags: config.auto ? { div: true } : {}
        },
        show_log: config.show_log // 控制台显示数据开关
    });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/sensor-sdk-h5/dist/autotrack.js
// module id = Bkpt
// module chunks = 1